module.exports = __webpack_public_path__ + "img/logo.da3d860b.png";